import PatientService from "../../Services/PatientService";

export const GETPATIENTDATAREQ = "GETPATIENTDATAREQ";
export const GETPATIENTDATASUCCESS = "GETPATIENTDATASUCCESS";
export const GETPATIENTDATAFAILED = "GETPATIENTDATAFAILED";
export const REMOVEPATIENTDATA = "REMOVEPATIENTDATA";

export const SAVE_LOGGED_USER = "SAVE_LOGGED_USER";
export const CLEAR_LOGGED_USER =  "CLEAR_LOGGED_USER";

export const getDataFromLocal = () => async (dispatch) => {
  try {
    const loggedUserJson = localStorage.getItem("patientData");
    const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;
    if (!loggedUser) return;
    let res = await PatientService.getPatient({
      patientId: loggedUser.patientId,
    });

    if (res?.data?.length > 0) {
      dispatch({
        type: GETPATIENTDATASUCCESS,
        payload: res?.data[0],
      });
    } else {
      dispatch({ type: GETPATIENTDATAFAILED });
    }
  } catch (error) {
    console.error(error);
  }
};

export const deleteDataFromLocal = () => async (dispatch) => {
  dispatch({ type: REMOVEPATIENTDATA });
  localStorage.clear();
};

export const saveLoggedUser = (user) => ({type:SAVE_LOGGED_USER,payload:user});
export const clearLoggedUser = (user) => ({type:CLEAR_LOGGED_USER,payload:user});
